export const MONTHLY_REVIEW_MAX_STAR = 5
export const MONTHLY_REVIEW_DEFAULT_STAR = 5
export const MONTHLY_REVIEW_MIN_STAR = 1
export const MONTHLY_REVIEW_CONTENT_MAX_LENGTH = 255
export const MONTHLY_REVIEW_START_DAY = 10
